/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LandingPageStatisticsDTO
 */
export interface LandingPageStatisticsDTO {
	/**
	 *
	 * @type {number}
	 * @memberof LandingPageStatisticsDTO
	 */
	studentsCount?: number;
	/**
	 *
	 * @type {number}
	 * @memberof LandingPageStatisticsDTO
	 */
	partnerCompaniesCount?: number;
	/**
	 *
	 * @type {number}
	 * @memberof LandingPageStatisticsDTO
	 */
	proposalsCount?: number;
	/**
	 *
	 * @type {number}
	 * @memberof LandingPageStatisticsDTO
	 */
	professorsCount?: number;
}

export function LandingPageStatisticsDTOFromJSON(
	json: any
): LandingPageStatisticsDTO {
	return LandingPageStatisticsDTOFromJSONTyped(json, false);
}

export function LandingPageStatisticsDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): LandingPageStatisticsDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		studentsCount: !exists(json, "studentsCount")
			? undefined
			: json["studentsCount"],
		partnerCompaniesCount: !exists(json, "partnerCompaniesCount")
			? undefined
			: json["partnerCompaniesCount"],
		proposalsCount: !exists(json, "proposalsCount")
			? undefined
			: json["proposalsCount"],
		professorsCount: !exists(json, "professorsCount")
			? undefined
			: json["professorsCount"],
	};
}

export function LandingPageStatisticsDTOToJSON(
	value?: LandingPageStatisticsDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		studentsCount: value.studentsCount,
		partnerCompaniesCount: value.partnerCompaniesCount,
		proposalsCount: value.proposalsCount,
		professorsCount: value.professorsCount,
	};
}
